export default __webpack_public_path__ + "static/dark-logo-a2639a6e06056a296ec9be88ecb63b16.svg";